'use client';

import { TypographyProps, styled } from '@mui/material';
import Typography from '@mui/material/Typography';

export const TypographyRegular = styled(Typography)<TypographyProps>(({ theme }) => ({
    fontFamily: theme.typography.fontFamilyRegular,
}));
